import React from "react";
import Icon from "../Icon";
import { FormattedUpload, UploadListQuery, ValidationError } from "../types";
import UploadCard from "./UploadCard";
import RecordsTable from "./RecordsTable";

interface Props {
  records: FormattedUpload[];
  totalUploads: number;
  listQuery: UploadListQuery;
  onListQueryChange: (next: UploadListQuery) => void;
  role: "editor" | "viewer";
  onUpload: (payload: { file: File; isInceptionToDate: boolean }) => void;
  uploading: boolean;
  uploadError?: ValidationError | null;
  onClearUploadError: () => void;
  onOpen: (record: FormattedUpload) => void;
  onOpenById: (publicId: string) => void;
  onRetry: (record: FormattedUpload) => void;
  onDownload: (record: FormattedUpload) => void;
  onRefresh: () => void;
  refreshing: boolean;
}

const UploadsTab: React.FC<Props> = ({
  records,
  totalUploads,
  listQuery,
  onListQueryChange,
  role,
  onUpload,
  uploading,
  uploadError,
  onClearUploadError,
  onOpen,
  onOpenById,
  onRetry,
  onDownload,
  onRefresh,
  refreshing,
}) => (
  <>
    {role === "viewer" ? (
      <div className="viewer-notice">
        <div className="viewer-notice-icon">
          <Icon name="shield" size={20} />
        </div>
        <div>
          <div className="viewer-notice-title">You have view-only access</div>
          <div className="viewer-notice-desc">
            You can see payment statements, but you can’t upload new ones or
            change existing entries. To get edit access, you’ll need the{" "}
            <strong>Investment Analyst</strong> or{" "}
            <strong>Operations Analyst</strong> role — ask your administrator.
          </div>
        </div>
      </div>
    ) : (
      <UploadCard
        onUpload={onUpload}
        uploading={uploading}
        error={uploadError}
        onClearError={onClearUploadError}
        onOpenRecord={onOpenById}
      />
    )}
    <RecordsTable
      records={records}
      total={totalUploads}
      listQuery={listQuery}
      onListQueryChange={onListQueryChange}
      onOpen={onOpen}
      onRetry={onRetry}
      onDownload={onDownload}
      onRefresh={onRefresh}
      refreshing={refreshing}
    />
  </>
);

export default UploadsTab;
